export const validateName = (name) => {
  if (!name || name.trim().length === 0) {
    return "이름을 입력해주세요.";
  }
  if (name.length < 2 || name.length > 20) {
    return "이름은 2~20자 이내로 입력해주세요.";
  }
  const nameRegex = /^[가-힣a-zA-Z]+$/;
  if (!nameRegex.test(name)) {
    return "이름은 한글 또는 영문만 입력 가능합니다.";
  }
  return null;
};

export const validatePhone = (phone) => {
  if (!phone || phone.trim().length === 0) {
    return "연락처를 입력해주세요.";
  }
  const phoneRegex = /^01[016789][0-9]{7,8}$/;
  const cleanPhone = phone.replace(/-/g, "");
  if (!phoneRegex.test(cleanPhone)) {
    return "올바른 휴대폰 번호 형식이 아닙니다.";
  }
  return null;
};

export const validateWinnerInfo = (name, phone) => {
  const errors = {};

  const nameError = validateName(name);
  if (nameError) errors.name = nameError;

  const phoneError = validatePhone(phone);
  if (phoneError) errors.phone = phoneError;

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};
